import * as React from 'react';

import {Card} from 'shells/card/card';
import {CheckboxButton} from 'shells/checkbox/checkbox-button';

type Props = {
    value: string;
    label: string;
};

export function ComparisonFieldsCheckboxButton(props: Props) {
    return (
        <div className='mb-8'>
            <Card hasShadow={true} hasBorder={false} borderRadius={8}>
                <CheckboxButton value={props.value}>{props.label}</CheckboxButton>
            </Card>
        </div>
    );
}
